import ServiceGraphQL from 'src/service/gql-service';
import { getVendor } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const GetVendor = (id) => {
  const params = {
    query: getVendor.QUERY,
    variables: {
      filter: {
        _id: id
      }
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
